import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Button, CheckBox, TextInput, TitleBar, View } from "../components/index.js";
import allMonsters from "../data/monsters.json";
import { getMonstersForThreatLevel, getPosition, getRandomThreat } from "../logic/createMonsters.js";
import * as actions from "../redux/actions/actions.js";
import MonsterTable from "./MonsterTable.js";

const monsterGroups = ["all", ...Array.from(new Set(allMonsters.map((m) => m.group).filter((g) => g)))];

const Play = ({ setStory }) => {
  const [threatLevelMin, setThreatLevelMin] = useState(20);
  const [threatLevelMax, setThreatLevelMax] = useState(50);
  const [minCreatureThreat, setMinCreatureThreat] = useState(0);
  const [monsterList, setMonsterList] = useState([]);
  const [rolledThreat, setRolledThreat] = useState(null);
  const [selectedMonster, setSelectedMonster] = useState(null);
  const [appendMonsters, setAppendMonsters] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState(["all"]);
  const nextId = useRef(0);

  useEffect(() => {
    // Optional: Handle potential initial data loading here if needed
    // (Consider using a separate data fetching hook or library)
  }, []);

  const handleGroupChange = (group) => {
    setSelectedGroups((prevSelectedGroups) => {
      if (group === "all") {
        return ["all"];
      }

      const newSelectedGroups = prevSelectedGroups.filter((g) => g !== "all");

      if (newSelectedGroups.includes(group)) {
        const filteredGroups = newSelectedGroups.filter((g) => g !== group);
        return filteredGroups.length === 0 ? ["all"] : filteredGroups;
      } else {
        return [...newSelectedGroups, group];
      }
    });
  };

  const getMonsters = async () => {
    const threat = getRandomThreat({ minParam: threatLevelMin, maxParam: threatLevelMax });
    setRolledThreat(threat);

    let monstersToRoll = allMonsters;
    if (!selectedGroups.includes("all")) {
      monstersToRoll = allMonsters.filter((m) => selectedGroups.includes(m.group));
    }

    const ret = getMonstersForThreatLevel({ threatLevel: threat, minCreatureThreat: minCreatureThreat, monsters: monstersToRoll });
    const newMonsters = ret.monsters.map((m) => ({
      ...m,
      position: getPosition(),
      uniqueId: nextId.current++,
    }));

    if (appendMonsters) {
      setMonsterList((prev) => [...prev, ...newMonsters]);
    } else {
      setMonsterList(newMonsters);
    }
  };

  const addMonster = () => {
    if (selectedMonster) {
      const monsterToAdd = allMonsters.find((m) => m.Creature === selectedMonster);
      if (monsterToAdd) {
        const newMonster = {
          ...monsterToAdd,
          position: getPosition(),
          uniqueId: nextId.current++,
        };
        setMonsterList((prev) => [...prev, newMonster]);
      }
    }
  };

  const removeMonster = (monsterToRemove) => {
    setMonsterList((prev) => prev.filter((monster) => monster.uniqueId !== monsterToRemove.uniqueId));
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"Play"}>
      <br></br>
      <View style={{ flexDirection: "row", maxHeight: "80px", alignItems: "flex-end" }}>
        <TextInput title="Min Threat level" variant="outlined" value={threatLevelMin} onChange={setThreatLevelMin} />
        <TextInput title="Max Threat level" variant="outlined" value={threatLevelMax} onChange={setThreatLevelMax} />
        <TextInput title="Min Creature Threat" variant="outlined" value={minCreatureThreat} onChange={setMinCreatureThreat} />
        <CheckBox label="Append" checked={appendMonsters} onChange={(e) => setAppendMonsters(e.target.checked)} />
        <Button style={{ maxWidth: "100px" }} onPress={getMonsters} text={"Carregar Monstros"} />
      </View>
      <View style={{ flexDirection: "row", alignItems: "center", marginTop: 10 }}>
        {monsterGroups.map((group) => (
          <CheckBox key={group} label={group} checked={selectedGroups.includes(group)} onChange={() => handleGroupChange(group)} />
        ))}
      </View>
      <View style={{ flexDirection: "row", maxHeight: "80px", alignItems: "flex-end", marginTop: 10 }}>
        <Autocomplete style={{ width: 300 }} options={allMonsters.map((m) => m.Creature)} onChange={(e, v) => setSelectedMonster(v)} renderInput={(params) => <TextField {...params} label="Add Monster" variant="outlined" />} />
        <Button style={{ maxWidth: "100px", marginLeft: 8 }} onPress={addMonster} text={"Add"} />
      </View>
      Threat rolled: {rolledThreat}
      {monsterList && <MonsterTable monsters={monsterList} onRemoveMonster={removeMonster} />}
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
  story: state.Reducer.story,
});

const mapDispatchToProps = (dispatch) => ({
  setStory: (story) => dispatch(actions.setStory(story)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Play);
